export const stringToNumber = (value: string | null | undefined): number | null => {
  if (!value) return null

  const number = Number(value)

  if (isNaN(number)) return null

  return number
}
